import {AfterViewInit, Component,  OnDestroy, Input, OnInit} from '@angular/core';
import {StreamsService}  from "../../services/streams.service";
import {StreamProject, StreamAccessKey} from "../../interfaces";
import { ClipboardService } from 'ngx-clipboard'
import { NbGlobalPosition, NbDialogService, NbToastrService } from '@nebular/theme';

 
@Component({
  selector: 'app-stream-qr-toggle-control',
  templateUrl: './stream-qr-toggle-control.component.html',
  styleUrls: ['./stream-qr-toggle-control.component.scss'],
})
export class StreamQrToggleControlComponent implements OnInit, OnDestroy{

 
   
  @Input() stream: StreamProject
 
  subscribeSetQr$:any = null
  
  qrOn:boolean = false
  loading:boolean = false


   constructor(
    public streamsService: StreamsService,
 
    private toastrService: NbToastrService

    ){
  }
 

   

 toggleQrOn(){
	if(this.qrOn){
          this.setQr(true)
	}else{
          this.setQr(false)
	}
 }


  setQr(qr){
    
    this.loading = true

	if( this.subscribeSetQr$){
      this.subscribeSetQr$.unsubscribe()
     }
    this.subscribeSetQr$ = this.streamsService.updateQrUnlocker(this.stream._id, qr).subscribe((stream: StreamProject)=>{
    
            this.stream.qrUnlocker = stream.qrUnlocker
		this.qrOn = stream.qrUnlocker
  
      this.loading = false
    },(error)=>{
      this.loading = false
  
      this.toastrService.show('','Сталася помилка сервера',{
        status: 'danger',
        icon:'',
        position: <NbGlobalPosition>'bottom-right'
          })
    })
  }


	   
  ngOnInit() { 
   
 
		this.qrOn = this.stream.qrUnlocker
  }

  
   ngOnDestroy() { 
    if( this.subscribeSetQr$){
      this.subscribeSetQr$.unsubscribe()
     } 
   }
 

 

  
}
